export enum PNLAndWhatIfSize {
  SMALL = "small",
  MEDIUM = "medium",
  LARGE = "large",
}

export type PnlEWRow = {
  win: string;
  winRaw: number;
  placed: string;
  placedRaw: number;
  unplaced: string;
  unplacedRaw: number;
  hasMarker?: boolean;
};

export type PNLAndWhatIfProps = {
  size?: PNLAndWhatIfSize;
  previousPnl?: string;
  pnl?: string;
  rawPnl?: number;
  pnlLose?: string;
  rawPnlLose?: number;
  whatIf?: string;
  rawWhatIf?: number;
  whatIfLose?: string;
  rawWhatIfLose?: number;
  disabled?: boolean;
  agnostic?: boolean;
  boosted?: boolean;
  pnlAndWhatIfEachWay?: PnlEWRow[];
};
